import { ArticleHeading1, ArticleHeading2, ArticleHeading5, TDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from 'react-scroll';

import * as style from './Intro.css';

import classNames from 'classnames';

interface IIntroProps {
  device: TDeviceType;
  title: string;
  date: string;
}

export const Intro: React.FC<IIntroProps> = ({ device, title, date }) => {
  const isPhone = device === 'phone';

  const TitleIntro = isPhone ? (
    <ArticleHeading1 color="primary_100" fontWeight="normal">
      {title}
    </ArticleHeading1>
  ) : (
    <h1 className={style['title']}>{title}</h1>
  );

  const TextIntro = isPhone ? ArticleHeading5 : ArticleHeading2;

  return (
    <div
      className={classNames(
        style['intro-container'],
        device === 'tablet' && style['container-tablet'],
        isPhone && style['container-mobile'],
      )}
    >
      <div className={style['text-block']}>
        <div className={style['title-container']}>{TitleIntro}</div>
        <TextIntro fontWeight="normal">
          Представляем рейтинг профессионалов, оказывающих услуги на рынке недвижимости. Рейтинг составлен за {date}{' '}
          года на основе{' '}
          <Link duration={1000} smooth={true} spy={true} to="faq">
            <span className={style['link-text']}>
              количества показов объявлений покупателям и арендаторам недвижимости на Циан{' '}
              <sup>
                <span className={style['info-img']} />
              </sup>
            </span>
          </Link>
          .
        </TextIntro>
      </div>
      <div className={style['cup-img']} />
    </div>
  );
};
